<app-pagination-footer-template
    [canSearch]="canSearch()"
    [paginationParameters]="paginationParameters()"
    [searchDisabled]="!totalEntities()"
    [selectedEntitiesNumber]="selectedEntitiesNumber()"
    [selectedLayerNumber]="selectedLayerNumber()"
    [totalEntities]="totalEntities()"
    (handleSearch)="handleSearch($event)"
    (onPageChange)="entitiesTableByLayerService.onPageChange($event)"
    (paginator)="paginator.emit($event)">
    <div class="flex flex-row gap-8 items-center justify-end">
        @if (updatedEntityNumber() !== undefined) {
            <span class="text-body-2 text-custom-dark-grey font-normal w-fit whitespace-pre-line text-left"
                >{{ updatedEntityNumber() }} {{ 'updatedEntities' | transloco | lowercase }}</span
            >
        }
        @if (canExecuteAction()) {
            <div class="flex items-start justify-end">
                <app-button
                    [disabled]="disable()"
                    [icon]="primaryButtonProps()!.icon"
                    [label]="primaryButtonProps()?.labelKey | transloco"
                    [matTooltip]="!disable() ? '' : (disableReason() | transloco)"
                    [type]="ButtonType.PRIMARY"
                    (onClick)="onPrimaryButtonClick.emit()" />
            </div>
        }
    </div>
</app-pagination-footer-template>
